// extracted by mini-css-extract-plugin
module.exports = {"styled_vehicle_selector":"StyledVehicleSelectorForm_styled_vehicle_selector__Bzw_R","new_vehicle_selector":"StyledVehicleSelectorForm_new_vehicle_selector__HNqmG"};